export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/users/login/',
    LOGOUT: '/auth/users/logout/',
    ME: '/auth/users/me/',
    UPDATE_PROFILE: '/auth/users/update_profile/',
    CHANGE_PASSWORD: '/auth/users/change_password/',
    FORGOT_PASSWORD: '/auth/users/forgot_password/',
    RESET_PASSWORD: '/auth/users/reset_password/',
    VERIFY_TOKEN: '/auth/users/verify_token/',
    TOKEN_REFRESH: '/auth/token/refresh/',
  },
  STATS: '/stats/',
  COMPANIES: {
    LIST: '/companies/',
    CREATE: '/companies/',
    DETAIL: (id: string) => `/companies/${id}/`,
    UPDATE: (id: string) => `/companies/${id}/`,
    DELETE: (id: string) => `/companies/${id}/`,
  },
  USERS: {
    LIST: '/auth/users/',
    CREATE: '/auth/users/',
    DETAIL: (id: string) => `/auth/users/${id}/`,
    UPDATE: (id: string) => `/auth/users/${id}/`,
    DELETE: (id: string) => `/auth/users/${id}/`,
  },
  DEVICES: {
    LIST: '/devices/',
    CREATE: '/devices/',
    DETAIL: (id: string) => `/devices/${id}/`,
    UPDATE: (id: string) => `/devices/${id}/`,
    DELETE: (id: string) => `/devices/${id}/`,
    REGISTER: '/devices/register/',
    HEARTBEAT: '/devices/heartbeat/',
    OFFLINE: '/devices/offline/',
  },
  SESSIONS: {
    LIST: '/sessions/',
    CREATE: '/sessions/',
    DETAIL: (id: string) => `/sessions/${id}/`,
    UPDATE: (id: string) => `/sessions/${id}/`,
    DELETE: (id: string) => `/sessions/${id}/`,
  },
  AUDIT: {
    LIST: '/audit/',
    DETAIL: (id: string) => `/audit/${id}/`,
  },
};
